import { Icon as IconComponent } from '../icon';

import { Icon, Title } from './config';
import { AlertData, AlertProps } from './types';
import {
  CloseButton,
  IconContainer,
  TextContainer,
  AlertContainer,
  ContentContainer,
} from './styles';

const Alert = ({ closeToast, toastProps }: AlertProps) => {
  const { message, options } = toastProps?.data as AlertData;
  const { type, icon, title } = options;

  return (
    <AlertContainer variant={type}>
      <ContentContainer>
        {type && (
          <IconContainer variant={type}>{icon ?? Icon[type]}</IconContainer>
        )}

        <TextContainer>
          {type && <h3>{title ?? Title[type]}</h3>}
          <div data-testid="error-message">{message}</div>
        </TextContainer>
      </ContentContainer>

      <CloseButton type="button" onClick={closeToast}>
        <IconComponent.CloseCircle />
      </CloseButton>
    </AlertContainer>
  );
};

export { Alert };
